<template>
	<page title="Manage Projects">
		<template #actions>
			<create-project v-if="auth.user_type === 1 || auth.user_type === 2" />
		</template>

		<projects-table title="All Projects" :projects="projects" />
		<v-btn
			elevation="5"
			color="warning"
			dark
			fixed
			bottom
			right
			class="floating-top-btn justify-start"
			@click="toTop">
			<v-icon left class="pr-3 pl-1">mdi-arrow-up-bold</v-icon>
			Back to top
		</v-btn>
	</page>
</template>
<script>
import Backend from '@/Layouts/Backend'
import Page from '@/Pages/Backend/Components/Page'
import ProjectsTable from '@/Pages/Backend/Projects/Table'
import CreateProject from '@/Pages/Backend/Projects/Create'

export default {
	components: { Page, ProjectsTable, CreateProject },
	layout: Backend,
	props: {
		projects: {
			type: [Array, Object],
			default: () => {},
			required: true
		},
		propertyTypes: {
			type: Array,
			default: null
		}
	},
	data () {
		return {
			auth: this.$page.props.auth
		}
	},
	methods: {
		toTop () {
			window.scrollTo({ top: 0, behavior: 'smooth' })
		}
	}
}
</script>
